mainApp.component('fwTable', {
	templateUrl: '/public/components/fw-table.component.html',
	bindings: {
		rulesType: '<', // the component either takes the rulesType from the bindings param or from the state param
		integrated: '@', // signifies this component isn't self contained and shouldn't handle actions on it's own or show table headers
		localRuleSettings: '<',
		onChange: '&',
		search: '<',
		selectionChange: '&',
	},
	controller: function ($scope, $timeout, $state, $element, GeneralUtilsService, IconsService, RulesService, FieldsService) {
		const ctrl = this;
		const FieldTypes = FieldsService.getFieldTypes();
		$scope.timeConstraints = { type: 'always', timeDef: {
				isA: 'Time', days: [], times: [], reoccurring: true
			} };
		const forcedNewCategories = FieldsService.getNewFieldType({
			component: FieldsService.getComponents().comboBox,
			dataURL: () => '/categories?forceNewCategories=true',
			sortField: 'display_name',
			searchField: 'display_name',
			// dataFilter : dataFilter,
			type: 'AppCategory',
			output: (item) => {
				item.type = 'AppCategory';
				return item;
			},
			info: item => item.description,
		});

		const fieldsForType = {
			WAN: {
				highLevelItems: {
					name: 'App/Category',
					id: 'highLevelItems',
					types: [
						{
							name: 'Any',
							field: FieldTypes.all,
						},
						{
							name: 'Applications',
							field: FieldTypes.wanApps,
						},
						{
							name: 'Custom Applications',
							field: FieldTypes.customApplications,
						},
						{

							name: 'Categories',
							field: forcedNewCategories,
						},
						{
							name: 'Custom Categories',
							field: FieldTypes.customCategories,
						},
						{
							name: 'Fully Qualified Domain Name',
							field: FieldTypes.FQDN,
						},
						{
							name: 'Domain Name',
							field: FieldTypes.TLD,
						},
						{
							name: 'IP Range',
							field: FieldTypes.adhocIpRange,
						},
					],
				},
				lowLevelItems: {
					name: 'Service/Port',
					id: 'lowLevelItems',
					types: [
						{
							name: 'Any',
							field: FieldTypes.all,
						},
						{
							name: 'Services',
							field: FieldTypes.services,
						},
						{
							name: 'Protocol/Port',
							field: FieldTypes.portsProtocols,
						}],
				},
				from: {
					name: 'From',
					id: 'from',

					types: [
						{
							name: 'Any',
							field: FieldTypes.all,
						},
						{
							name: 'Site',
							field: FieldTypes.sites,
						}, {
							name: 'Directory Users',
							field: FieldTypes.dsUser,
						}, {
							name: 'VPN User',
							field: FieldTypes.accesslogins,
						}, {
							name: 'Groups',
							field: FieldTypes.groups,
						}, {
							name: 'Hosts',
							field: FieldTypes.subnets,
						}, {
							name: 'Networks',
							field: FieldTypes.ipRanges,
						}, {
							name: 'Floating Ranges',
							field: FieldTypes.floatingIps,
						}, {
							name: 'IP Address',
							field: FieldTypes.ips,
						}],
				},
				to: {
					name: 'To',
					id: 'to',
					types: [
						{
							name: 'Any',
							field: FieldTypes.all,
						},
						{
							name: 'Site',
							field: FieldTypes.sites,
						}, {
							name: 'Directory Users',
							field: FieldTypes.dsUser,
						}, {
							name: 'VPN User',
							field: FieldTypes.accesslogins,
						}, {
							name: 'Groups',
							field: FieldTypes.groups,
						}, {
							name: 'Hosts',
							field: FieldTypes.subnets,
						}, {
							name: 'Networks',
							field: FieldTypes.ipRanges,
						}, {
							name: 'Floating IP',
							field: FieldTypes.floatingIps,
						}, {
							name: 'IP Address',
							field: FieldTypes.ips,
						}],
				},
			},
			OUTBOUND_INTERNET: {
				highLevelItems: {
					name: 'App/Category',
					id: 'highLevelItems',
					types: [
						{
							name: 'Any',
							field: FieldTypes.all,
						}, {
							name: 'Applications',
							field: FieldTypes.internetApps,
						},
						{
							name: 'Custom Applications',
							field: FieldTypes.customApplications,
						},
						{
							name: 'Categories',
							field: forcedNewCategories,
						},
						{
							name: 'Custom Categories',
							field: FieldTypes.customCategories,
						},
						{
							name: 'Fully Qualified Domain',
							field: FieldTypes.FQDN,
						},
						{
							name: 'Domain Name',
							field: FieldTypes.TLD,
						},
						{
							name: 'IP Range',
							field: FieldTypes.adhocIpRange,
						},
						{
							name: 'Countries',
							field: FieldTypes.countries,
						},
						{
							name: 'Remote ASN',
							field: FieldTypes.asn,
						},
					],
				},
				lowLevelItems: {
					name: 'Service/Port',
					id: 'lowLevelItems',
					types: [
						{
							name: 'Any',
							field: FieldTypes.all,
						}, {
							name: 'Services',
							field: FieldTypes.services,
						}, {
							name: 'Protocol/Port',
							field: FieldTypes.portsProtocols,
						}],
				},
				from: {
					name: 'From',
					id: 'from',
					types: [
						{
							name: 'Any',
							field: FieldTypes.all,
						},
						{
							name: 'Site',
							field: FieldTypes.sites,
						}, {
							name: 'Directory Users',
							field: FieldTypes.dsUser,
						}, {
							name: 'VPN User',
							field: FieldTypes.accesslogins,
						}, {
							name: 'Groups',
							field: FieldTypes.groups,
						}, {
							name: 'Hosts',
							field: FieldTypes.subnets,
						}, {
							name: 'Networks',
							field: FieldTypes.ipRanges,
						}, {
							name: 'Floating IP',
							field: FieldTypes.floatingIps,
						}, {
							name: 'IP Address',
							field: FieldTypes.ips,
						}],
				},
			},
		};

		let indexesChangedOrder = []; // nirtodo: move all the ordering logic to ngtable or an "ordered table" component
		let entityType;
		let origNetworkRules;
		let currentInlineActionsItem;
		let tableHeader = [];
		let rulesType;
		let rulesToRemove = [];

		const FREQUENCIES = ['IMMEDIATE', 'HOURLY', 'DAILY',  'WEEKLY'];

		ctrl.rulesEnabled = false;
		ctrl.loading = false;

		function updateLocalRuleSettings(newSettings) {
			ctrl.localRuleSettings = { rules: newSettings[rulesType.itemsField] || newSettings.rules, enabled: newSettings[rulesType.enabledField] || newSettings.enabled };
			ctrl.datamodified = new Date().getTime();
		}

		function getData(fw) {
			ctrl.loading = true;
			var type = fw.toUpperCase() + RulesService.FIREWALL_RULE_POSTFIX;
			store.fetch({
				method: 'POST',
				path: 'getRules',
				queryParams: {
					accountId: $state.params.accountId,
					rulesType: type,
				},
				success: function (data) {
					updateLocalRuleSettings(data);
					ctrl.loading = false;
					$scope.$digest();
				},
			});
		}

		ctrl.$onInit = function () {
			ctrl.rulesType = ctrl.rulesType || $state.current.type;
			ctrl.fields = fieldsForType[ctrl.rulesType];
			entityType = ctrl.rulesType.toUpperCase() + RulesService.FIREWALL_RULE_POSTFIX; // used for saving and deleting
			rulesType = RulesService.getRuleTypeOfEntityType(entityType);

			if (!ctrl.integrated) {
				tableHeader = RulesService.getFields(ctrl.rulesType);
			}

			getData(ctrl.rulesType);

			ctrl.tableConfig = {
				searchId: $state.params.ruleId,
				type: entityType,
				directions: ['TO', 'BOTH'],
				changeDir: function (item) {
					for (var i = 0; i < this.directions.length; i++) {
						if (item.dir === this.directions[i]) {
							if (i + 1 < this.directions.length) {
								item.dir = this.directions[i + 1];
							} else {
								item.dir = this.directions[0];
							}
							break;
						}
					}
					$('#' + entityType + '-row-' + item.id + ' .direction').data('title', item.dir);
				},
				ruleActions: ['ALLOW', 'BLOCK', 'PROMPT'],
				actionData: {
					ALLOW: { name: 'Allow', icon: 'allow', class: 'action-allow' },
					BLOCK: { name: 'Block', icon: 'block', class: 'action-block' },
					PROMPT: { name: 'Prompt', icon: 'prompt', class: 'action-alert' },
				},
				changeAction: function (item) {
					$scope.$root.$emit('$openPopup', ctrl.rulesType + 'actions', 'action_' + entityType + item.id);
					$scope.actionsConfig.selectedAction = item.action;
					$scope.actionsConfig.rule = item;
				},
				dataURL: function () {
					return null;
				},
				titleSearch: ctrl.integrated ? false : 'Rules',
				alternativeHead: tableHeader,
				hideHead: ctrl.integrated,
				clientSideSearch: true,
                searchPredicate: function(item, valueToSearch) {
                    return (item.description.toLowerCase().includes(valueToSearch)) ||
                            (Object.values(item.from).some(x => x?.display_name?.toLowerCase().includes(valueToSearch))) ||
                            (Object.values(item.to).some(x => x?.display_name?.toLowerCase().includes(valueToSearch))) ||
                            (Object.values(item.highLevelItems).some(x => x?.display_name?.toLowerCase().includes(valueToSearch))) ||
                            (Object.values(item.lowLevelItems).some(x => x?.display_name?.toLowerCase().includes(valueToSearch)));
                },
				noSearch: true,
				noDataMessage: ' ',
				specialActions: ctrl.integrated ? null : [
					{
						icon: 'simple-plus',
						text: 'ADD RULE',
						tooltip: 'Add',
						id: 'add-fwRule',
						innerActions: [
							{
								icon: 'top',
								name: 'Top',
								func: function () {
									addRule(0);
									const targetElId = 'inner-action-add-fwRule';
									$scope.$root.toggleDropDown(targetElId);
								},
							},
							{
								icon: 'bottom',
								name: 'Bottom',
								func: function () {
									addRule();
									const targetElId = 'inner-action-add-fwRule';
									$scope.$root.toggleDropDown(targetElId);
									$timeout(function () {
										const $document = $(document);
										$document.scrollTop($document.height());
									}, 0, false);
								},
							},
						],
						func: function (selectedItems, tableConfig, $event) {
							const targetElId = 'inner-action-add-fwRule';
							$scope.$root.toggleDropDown(targetElId, $event);
						},
					},
				],
				rulesField: rulesType.itemsField,
				rulesFields: ctrl.fields,
				fields: [
					{
						label: 's',
						path: '',
						noSort: true,
						template: `
						<div class="arrows-wrapper">
							<a title="Move Priority Up" role="button" ng-disabled="items.indexOf(item) === 0" ng-click="tableConfig.changePriority('up', item, $event)"><svg class="icon icon-arrow"><use xlink:href="/public/images/icons/main.svg#icon-toggle-up"></use></svg></a>
							<a title="Move Priority Down" role="button" ng-disabled="items.indexOf(item) === items.length - 1" ng-click="tableConfig.changePriority('down', item, $event)"><svg class="icon icon-arrow"><use xlink:href="/public/images/icons/main.svg#icon-toggle-down"></use></svg></a>
						</div>`,
					},
					{
						label: '', path: '', noSort: true, template: '<fw-rule item="item" table-config="tableConfig"  rule-type="tableConfig.type" field="tableConfig.rulesField" fields="tableConfig.rulesFields"></fw-rule>'
					},
				],
				extraFieldsToSearch: [{ path: 'description' }],
				defer: true,
				parseData: function (data) {
					if (ctrl.localRuleSettings) { // if we already have localRuleSettings (after saving) we use it
						data = ctrl.localRuleSettings;
					}
					if (!data) {
						return null;
					}

					data.rules = data.rules.sort(function (o1, o2) {
						return o1.priority - o2.priority;
					});
					data.rules.forEach(function (rule) {
						rule.name = rule.description;
					});
					if (!isSystemLogin) {
						data.rules = data.rules.filter((rule) => !rule.systemRule);
					}

					origNetworkRules = angular.copy(data);
					ctrl.rulesEnabled = data.enabled;
					return data.rules;
				},
				sortList: [{ sortField: 'priority', sortDir: 'ASC' }],
				changePriority: function (direction, item, $event) {
					const index = this.items.indexOf(item);
					$event.stopPropagation();
					var $thisEl = $($element[0]);
					$thisEl.find('.order-change').removeClass('order-change');
					if ((index === 0 && direction === 'up') || (index === this.items.length - 1 && direction === 'down') || index < 0 || item.systemRule) {
						return;
					}

					const targetPriority = item.priority + (direction === 'up' ? -1 : 1);
					const sourcePriority = item.priority;

					if (index !== 0 && direction === 'up') {
						const targetItem = this.items[index - 1];
						if (targetItem.systemRule) {return;}

						targetItem.priority = sourcePriority;
						swapRules(this.items, index, index - 1);
					}
					if (index !== this.items.length - 1 && direction !== 'up') {
						const targetItem = this.items[index + 1];
						if (targetItem.systemRule) {return;}
						targetItem.priority = sourcePriority;
						swapRules(this.items, index, index + 1);
					}

					item.priority = targetPriority;

					this.refreshViewItems = new Date().getTime();

					indexesChangedOrder.forEach(function (i) {
						$thisEl.find('.row-' + i).first().addClass('order-change');
					});

					indexesChangedOrder = [];
				},
				editConstraints: function (item, id) {
					if (!item.constraint) {
						item.constraint = { predicates: {}, op: 'OP_EQ' };
					}
					$scope.timeConstraints = { type: 'always', timeDef: {
						isA: 'Time', days: [], times: [], reoccurring: true
					} };

					if (item.constraint.predicates.time) {
						item.constraint.predicates.time.values.forEach(function (value) {
							if (typeof value === 'string') {
								$scope.timeConstraints.type = value;
							} else {
								$scope.timeConstraints.type = 'custom';
								$scope.timeConstraints.timeDef = value;
							}
						});
					} else {
						$scope.timeConstraints.type = 'always';
					}

					$scope.scopeSelection = { item: item };

					$scope.$root.openPopup(ctrl.rulesType + 'constraintEditor');
				},
				clientSidePaging: true,
				pageSize: 80,
				hideCheckboxes: true,
				noAutoSelect: true,
				nameField: 'description',
				innerLoader: true,
				icons: IconsService.getIcons('policy'),
				items: [],
				openInlineActions: function (item, $event) {
					$event.stopPropagation();
					$scope.$root.$emit('$togglePopup', ctrl.rulesType + 'fw-inline-actions', 'inline-actions_' + entityType + item.id, { leftMod: $scope.$root.menuClosed ? -46 : -205 });
					currentInlineActionsItem = item;
				},
				editTrigger: function (item, id) {
					$scope.$root.$emit('$openPopup', 'triggerSelector', 'trigger_' + id);

					let alertFrequency = item.alertFrequency ? item.alertFrequency : "HOURLY";
					let addresses = item.addresses ? item.addresses : 'All Admins';

					// in case of quality issues, only the mailing list can be edited by the user
					$scope.scopeSelection = {
						item: item, trigger: item.trigger, alertFrequency: alertFrequency, addresses: addresses, createEvent: item.createEvent, showEventToggle: true
					};
				},
				afterUpdate: function () {
					ctrl.currentEditedRow = this.items[0];
				},
				allowPropagation: true,
				stickyHead: true,
			};

			if (ctrl.integrated && ctrl.onChange) {
				$scope.$watch('$ctrl.tableConfig.items', function () {
					if (origNetworkRules && ctrl.tableConfig.items) {
						ctrl.onChange({ rulesType: ctrl.rulesType, items: ctrl.tableConfig.items, isChanged: !angular.equals(ctrl.tableConfig.items, origNetworkRules.rules) });
					}
				}, true);
			} else {
				$scope.$root.hasChanges = function () {
					if (!origNetworkRules) return;
					return !angular.equals(ctrl.tableConfig.items, origNetworkRules.rules) || ctrl.rulesEnabled !== origNetworkRules.enabled;
				};
			}

			const jqEl = $($element[0]);
			$scope.alternativeHeadEl = jqEl.find('.fw-actions');
			$scope.tableEl = jqEl.find('.firewall');
		};

		$scope.frequencies = FREQUENCIES;

		$scope.saveTrigger = function (trigger) {
			// nirtodo: clear this mess
			$scope.scopeSelection.item.trigger = $scope.scopeSelection.trigger;
			$scope.scopeSelection.item.createEvent = $scope.scopeSelection.createEvent;
			if ($scope.scopeSelection.trigger || trigger) {
				$scope.scopeSelection.item.alertFrequency = $scope.scopeSelection.alertFrequency;
				$scope.scopeSelection.item.addresses = $scope.scopeSelection.addresses;
			}
			$scope.$root.$emit('$closePopup', 'triggerSelector');
		};

		store.fetch({
			method: 'POST',
			data: { dateField: '', from: 0, limit: -1 },
			dataObj: 'dataConfig',
			path: '/getMailingLists?accountId=' + $state.params.accountId,
			success: function (data) {
				$scope.mailingLists = [];
				data.items.forEach(function (item) { $scope.mailingLists.push(item.name); });
			},
		});

		ctrl.$postLink = function () {
			if (ctrl.integrated && !ctrl.datamodified && ctrl.localRuleSettings) {
				ctrl.datamodified = new Date().getTime();
			}
		};

		$scope.$on('updateRules', function (_event, type) {
			if (type === ctrl.rulesType) {
				ctrl.datamodified = new Date().getTime();
			}
		});


		ctrl.postSave = function (newData) {
			ctrl.loading = false;
			$scope.$root.handleServerResponse(newData, 'fwRules', 'Firewall rules were saved successfully');
			if (newData.status === 'OK') {
				updateLocalRuleSettings(newData.model);
				rulesToRemove = [];
			}
		};

		ctrl.postDelete = function (itemsDeleted, newData) {
			updateLocalRuleSettings(newData.data);
		};

		// send save request
		ctrl.getStoreConfiguration = function () {
			var fields = "['" + rulesType.itemsField + "', '" + rulesType.enabledField + "']";
			var data = { newSaveMethod: true, id: $state.params.accountId };
			data[rulesType.itemsField] = ctrl.tableConfig.items;
			data[rulesType.enabledField] = ctrl.rulesEnabled;
			data.itemsToDelete = {};
			data.itemsToDelete[rulesType.itemsField] = rulesToRemove;
			ctrl.loading = true;
			return {
				url: '/edit',
				data: data,
				dataObj: 'json',
				queryParams: {
					accountId: $state.params.accountId,
					save: true,
					fields: fields,
				},
			};
		};

		ctrl.deleteRule = function () {
			$scope.$root.confirm('Are you sure you would like to delete the rule ' + currentInlineActionsItem.name + '? (The rule will be deleted only after saving the firewall)', function () {
				const itemIndexToRemove = ctrl.tableConfig.items.indexOf(currentInlineActionsItem);
				currentInlineActionsItem.type = entityType;
				rulesToRemove.push(currentInlineActionsItem);
				ctrl.tableConfig.items.splice(itemIndexToRemove, 1);
				ctrl.tableConfig.items.forEach(function (item) {
					if (item.priority > currentInlineActionsItem.priority) {
						item.priority--;
					}
				});
				currentInlineActionsItem = null;
			}, null, null, function () {
				currentInlineActionsItem = null;
			});
			$scope.$root.$emit('$closePopup', ctrl.rulesType + 'fw-inline-actions');
		};

		ctrl.addRuleAbove = function () {
			addRule(currentInlineActionsItem.priority - 1);
		};
		ctrl.addRuleBelow = function () {
			addRule(currentInlineActionsItem.priority);
		};
		ctrl.addException = function () {
			addRule(null, currentInlineActionsItem);
		};

		ctrl.selectedItemsChanged = function (newSelections) {
			if (ctrl.selectionChange) {
				ctrl.selectionChange({ rulesType: ctrl.rulesType, newSelectionItems: newSelections });
			}
		};

		ctrl.enableUseNewFW = () => {
			$scope.$root.confirm(`Transferring the security policy to the new firewalls is permanent. You can't undo this action!
				Note: You're about to disable the deprecated WAN Firewall, Internet Firewall, and URL Filtering..
				`,
			() => {
				store.action({
					path: '/enableUseNewFW',
					queryParams: { accountId: $state.params.accountId },
					success: (data) => {
						$scope.$root.handleServerResponse(data, '', 'Success! Now using the new ordered firewall');

						if (data.status === 'OK') {
							$scope.$root.useNewFW = true;
						}
					},
				});
			},);
		};

		function addRule(priority, parent) {
			if (!priority && priority !== 0) {
				let targetPriority = 0;
				ctrl.tableConfig.items.forEach((item) => { if (!item.systemRule) targetPriority++; });
				priority = targetPriority;
			}
			const newRule = RulesService.addNewCreatedRule(ctrl.tableConfig.items, ctrl.rulesType, priority, parent, null);
			if (newRule) {
				if (ctrl.rulesType === 'WAN') {
					newRule.to.push(FieldsService.getFieldTypes().all.output());
				}
			}
			$scope.$root.closeDropDown(ctrl.rulesType + 'inner-action-add-fwRule');
			$scope.$root.$emit('$closePopup', ctrl.rulesType + 'fw-inline-actions');
			currentInlineActionsItem = null;
		}

		var swapRules = function (arr, indexA, indexB) {
			var temp = arr[indexA];
			arr[indexA] = arr[indexB];
			arr[indexB] = temp;
			indexesChangedOrder.push(indexA);
			indexesChangedOrder.push(indexB);
		};


		$scope.addConstraints = function () {
			const item = $scope.scopeSelection.item;
			const fieldName = 'src_time';
			if ($scope.timeConstraints.type === 'always') {
				delete item.constraint.predicates.time;
			} else if ($scope.timeConstraints.type === 'workingHours') {
				item.constraint.predicates.time = { field: { name: fieldName }, op: 'OP_EQ', values: ['workingHours'] };
			} else { // custom
				item.constraint.predicates.time = { field: { name: fieldName }, op: 'OP_EQ', values: [$scope.timeConstraints.timeDef] };
			}

			$scope.$root.closePopup(ctrl.rulesType + 'constraintEditor');
		};

		$scope.actionsConfig = {
			selectedAction: null,
		};

		$scope.setAction = function (popup) {
			$scope.actionsConfig.rule.action = $scope.actionsConfig.selectedAction;
			$scope.$root.$emit('$closePopup', popup);
		};
	},
});
